import { Add, Person, Search } from '@mui/icons-material';
import {
  Box,
  Container,
  IconButton,
  InputAdornment,
  LinearProgress,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useUserMappings } from 'shared/queries';
import { UserInfo } from 'shared/types';

interface UserMappingListPageProps {
  user: UserInfo;
}

export function UserMappingListPage({ user }: UserMappingListPageProps) {
  const [search, setSearch] = useState('');
  const { userMappings, isFetching } = useUserMappings();
  const history = useHistory();

  const navigateToUserMapping = (userId: string) => () => {
    history.push(ROUTES.toUserCommodities(userId));
  };

  const navigateToNewUserMapping = () => {
    history.push(ROUTES.newUserMapping);
  };

  const filteredMappings = (userMappings || []).filter(mapping => `${mapping.name}${mapping.email}`.includes(search));
  return (
    <Container sx={{ p: 2 }}>
      <Box height={4}>{isFetching && <LinearProgress />}</Box>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <TextField
          id='user-mapping-search'
          label='Search Users'
          type='search'
          value={search}
          onChange={e => {
            setSearch(e.target.value);
          }}
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <Search />
              </InputAdornment>
            ),
          }}
        />
        {user.isInsightEmployee && (
          <Box>
            <IconButton size='large' onClick={navigateToNewUserMapping}>
              <Add />
            </IconButton>
          </Box>
        )}
      </Box>
      <List>
        {filteredMappings.map(mapping => (
          <ListItemButton key={mapping.id} onClick={navigateToUserMapping(mapping.id)}>
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            <ListItemText primary={mapping.name} secondary={mapping.email} />
          </ListItemButton>
        ))}
      </List>
    </Container>
  );
}
